/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Days from './Days/index'
import Flags from './Flags/index'
import From from './From/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import To from './To/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsSettings/Settings/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Sending window"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXxs}
 color={dtColorsNeutral500}
 text="Setup timeframe within which comms are allowed to be sent."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXxs}
 color={dtColorsNeutral500}
 text="Federal regulations in the U.S., like the TCPA, prohibit sending marketing texts before 8 a.m. and after 9 p.m. in the recipient's local time. Many CRMs have built-in 'quiet hours' features that automatically block sends outside of this window to ensure compliance and prevent higher opt-out rates or carrier blocks."
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={dtSpaceS}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<From
  viewPath={`${viewPath}/From`}
/>
<To
  viewPath={`${viewPath}/To`}
/>
</div>
<Days
  viewPath={`${viewPath}/Days`}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceL}
 level="h4"
 text="Appointment flags"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Setup flags for appointment reminder related comms."
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={dtSpaceS}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
>
{childProps => (
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Flags
  viewPath={`${viewPath}/Flags`}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
{children}
</React.Fragment>)
}